import React, { useEffect, useState } from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { FaRegCalendarAlt } from "react-icons/fa";
import { GetInTouchFormSeminar } from '../components';

const HeroSeminars = ({ title, subtitle, bgImageData, stopRef, floatingFormRef }) => {
    const [isFloating, setIsFloating] = useState(false);
    const [hasReachedStop, setHasReachedStop] = useState(false);


    useEffect(() => {
        const handleScroll = () => {
            if (!floatingFormRef.current || !stopRef?.current) return;
    
            const formHeight = floatingFormRef.current.offsetHeight;
            const formBottomInViewport = 128 + formHeight; // top-32 + height
    
            const stopBottomInViewport = stopRef.current.getBoundingClientRect().bottom;
    
            const shouldHide = formBottomInViewport >= stopBottomInViewport;
    
            setHasReachedStop(shouldHide);
        };
    
        window.addEventListener("scroll", handleScroll);
        handleScroll(); // Initial check
        return () => window.removeEventListener("scroll", handleScroll);
    }, [floatingFormRef, stopRef]);
    
    
    const gradientOverlayStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "linear-gradient(to top, #162054 0%, #162054 10%, transparent 100%)",
        zIndex: -1,
    };

    return (
        <>
            <div className="w-full h-full relative m-0 p-0 grid grid-cols-1 lg:grid-cols-12 min-h-[500px] xl:grid hidden">
                <GatsbyImage
                    className="absolute w-full h-full col-span-full"
                    style={{ position: "absolute", zIndex: -2 }}
                    image={bgImageData}
                    alt="Full Width Background Image"
                    objectFit="cover"
                />
                <div style={gradientOverlayStyle} className="col-span-full" />

                <div className="col-span-12 lg:col-start-2 lg:col-span-10 pt-24 pb-36 px-8 md:px-0 relative z-10 h-full">
                    {/* Title & Subtitle */}
                    <div className="absolute bottom-10 left-0 w-full px-8 md:px-0">
                        <div className="grid grid-cols-1 lg:grid-cols-12">
                            <div className="col-span-12 lg:col-span-8 xl:col-span-6">
                                <h1 className="text-5xl text-white font-semibold mb-2">{title}</h1>
                                <div className="flex items-center text-white mt-4">
                                    <FaRegCalendarAlt className="text-2xl mr-2" />
                                    <span className="text-white pr-10">{subtitle}</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Floating Form */}
                    <div
                        ref={floatingFormRef}
                        className={`hidden xl:block transition-all duration-300`}
                        style={{
                            position: 'fixed',
                            top: '8rem',
                            right: '10rem',
                            width: '500px',
                            zIndex: 30,
                            opacity: hasReachedStop ? 0 : 1,
                            visibility: hasReachedStop ? 'hidden' : 'visible',
                            pointerEvents: hasReachedStop ? 'none' : 'auto',
                            transition: 'opacity 0.3s ease, visibility 0.3s ease',
                        }}
                        >

                        <div className="bg-white rounded-2xl shadow-lg p-10">
                            <h2 className="text-2xl text-holborn-mid-blue font-semibold mb-1 text-center">
                                Register for the seminar
                            </h2>
                            <GetInTouchFormSeminar />
                        </div>
                    </div>

                </div>
            </div>

            {/* Mobile version */}
            <section className="xl:hidden pb-0">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 text">
                    <div className="col-span-full lg:grid-cols-10 lg:col-start-2 lg:col-end-11">
                        <div className="text">
                            <h2 className="text-3xl text-holborn-blue font-semibold mb-1">{title}</h2>
                            <div className="flex items-center">
                                <p className="text-holborn-mid-blue font-semibold">{subtitle}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default HeroSeminars;
